







// --- Vue & Template imports ---
import { Component, Prop, Vue } from 'vue-property-decorator';

// --- Services ---
import AuthService from '@/services/auth';

@Component
export default class LogoutPage extends Vue {

  async beforeMount() {
    // trigger the logout service call
    await AuthService.logout();
  }
}
